// extracted by mini-css-extract-plugin
export var column = "registerFlow-module--column--bab24";
export var content = "registerFlow-module--content--95ba3";
export var footer = "registerFlow-module--footer--67bf1";
export var header = "registerFlow-module--header--445ee";
export var heading = "registerFlow-module--heading--fb203";
export var intro = "registerFlow-module--intro--9c1a0";
export var trialIntro = "registerFlow-module--trial-intro--88a94";
export var wrapper = "registerFlow-module--wrapper--66ee2";